import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TourState {
  completedTours: Record<string, boolean>;
  hasSeenAnyTour: boolean;
}

interface TourActions {
  markCompleted: (tourId: string) => void;
  resetTour: (tourId: string) => void;
  resetAll: () => void;
}

type TourStore = TourState & TourActions;

export const useTourStore = create<TourStore>()(
  persist(
    (set) => ({
      // State
      completedTours: {},
      hasSeenAnyTour: false,

      // Actions
      markCompleted: (tourId: string) =>
        set((state) => ({
          completedTours: { ...state.completedTours, [tourId]: true },
          hasSeenAnyTour: true,
        })),

      resetTour: (tourId: string) =>
        set((state) => {
          const updated = { ...state.completedTours };
          delete updated[tourId];
          return { completedTours: updated };
        }),

      resetAll: () =>
        set({ completedTours: {}, hasSeenAnyTour: false }),
    }),
    {
      name: 'aflow-tour',
      partialize: (state) => ({
        completedTours: state.completedTours,
        hasSeenAnyTour: state.hasSeenAnyTour,
      }),
    }
  )
);

export function isTourCompleted(tourId: string): boolean {
  return useTourStore.getState().completedTours[tourId] === true;
}
